module.exports = __webpack_public_path__ + "img/good_empty.d98bb939.png";